import Uppy from '@uppy/core';
import { DragDrop, StatusBar } from '@uppy/react';
import XHR from '@uppy/xhr-upload';
import { useEffect, useState } from 'react';
import { API_URL } from '../../config/constants';

import { toast } from 'react-toastify';

import '@uppy/core/dist/style.min.css';
import '@uppy/drag-drop/dist/style.min.css';
import '@uppy/status-bar/dist/style.min.css';
import { randomUid } from '../../utils/utils';
import { useSelector } from 'react-redux';
import { selectTranslations } from '../../services/i18n/i18nSlice';

const customFutureDate = (minutes) => {
    const _current_date = new Date()
    return new Date(_current_date.getTime() + minutes*60000);
}

export default function FileUploader ({folderId, fileType="material", uploader_id=randomUid(), onUpload, onUploadEnd}) {

    const t = useSelector(selectTranslations)

    const [uppy] = useState( () => new Uppy({debug: true, autoProceed:true})
        .use(XHR, {  
            id: uploader_id,
            endpoint: `${API_URL}/upload_file?${fileType ? 'file_type='+fileType : ""}${folderId ? '&folder_id='+folderId : ""}`, 
            withCredentials: true,
            getResponseData(responseText, response) {
                console.log(response);
                if(response?.response){
                    let _response = structuredClone(response?.response)
                    _response = JSON.parse(_response)
                    if(response?.status !== 200){
                        console.log(_response);
                        if(_response?.detail === "uploaded file size exceeds maximum allowed file size")
                            toast.error(t.upload.file_too_big)
                        else
                            toast.error(t.upload.error_upload)
                    } else{
                        toast.success("Materiale caricato con successo")
                        onUploadEnd()
                    }
                }
            },
            onShouldRetry(err, retryAttempt, options, next) {
                if (err?.originalResponse?.getStatus() === 400) {
                    console.log("Errore upload");
                    return false;
                }
                return next(err);
            },
        })
        .on('upload-error', (file, error, response) => {
            console.error(`Errore durante l'upload del file ${file.name}:`, error, response);
            if (response?.status === 413) {
                toast.error(`${t.upload.file_too_large}: ${file.name}`);
            } else {
                toast.error(`${t.upload.error_upload}: ${file.name}`);
            }
        })
    );

    return(
        <div>
            <DragDrop uppy={uppy} />
            <StatusBar uppy={uppy}/>
        </div>
    )

}

